import { useLocation } from "react-router-dom";

// Persistent top-right QR badge for the projector screen at the table --
// "scan to reali7y-over.run". Mounted once, above <Routes> in App.tsx, so it
// renders on every page including (structurally) /game.
//
// Positioned BELOW <Countdown/> (which already occupies the exact top-right
// corner -- fixed, top:5px, right:5px, width:200px -- on nearly every view)
// rather than replacing or moving it: Countdown is out of this component's
// scope, and stacking avoids fighting it for the same pixels on every page
// that renders both.
//
// NOT rendered on /game: the in-game ChallengeDialog trigger lives in the
// exact same corner (fixed, right:7px, top:70px) and the two would visually
// overlap. This is signage for a projector at the table, not for someone
// actively playing on their own device -- same reasoning VideoBackground
// already uses to skip /game.
function ProjectorQR() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/game")) {
    return null;
  }
  return (
    <div className="ro-projector-qr">
      <img src="/assets/images/ro-qr.png" alt="Scan to visit reali7y-over.run" />
      <div className="ro-projector-qr-caption">
        Races today at: 12, 2, 4! 3 players each race!
      </div>
    </div>
  );
}

export { ProjectorQR };
